import { FlowHubMainLayout } from "./components/Flow-Hub"

export const FlowHub = () => {
    return (
        <FlowHubMainLayout />
    )
}